import { GAME_ID, REDUX_ACTIONS, SCREENS } from '../../data/constants';

export const initialState = {
  interactionLocked: false,
};

const uxReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        interactionLocked: action.payload === SCREENS.ONBOARDING_VIEW,
      };
    case REDUX_ACTIONS.SET_INTERACTION_LOCKED:
      return {
        ...state,
        interactionLocked: action.payload.interactionLocked,
      };
    default:
      return state;
  }
};

export default uxReducer;
